// extracted by mini-css-extract-plugin
module.exports = {"burger":"Burger_burger__AdXXm"};